import { Link } from "react-router-dom";

export function MyFooter() {
  return (
    <div className="footer">
      <div className="footer_row1">
        <div>surfwetter.ch</div>
        <div className="footer_links"><Link to="/impressum">Impressum</Link></div>
      </div>
      <div className="footer_update">Version <Link to="/changelog">0.2.0</Link> - 01.08.2026</div>
    </div>
  );
}

export default MyFooter;
